import React, { useContext } from "react";
import { ThemeContext } from "../components/themeContext";
import toggleOff from "../assets/svg-icons/toggleOff.svg";
import toggleOn from "../assets/svg-icons/toggleOn.svg";
import { LucideSun } from "lucide-react";
import { LucideMoon } from "lucide-react";

const ThemeToggler = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  const handleThemeSwitch = () => {
    // Manually toggle between light and dark themes
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };

  return (
    <button onClick={handleThemeSwitch}>
      <div className="flex items-center justify-center size-9 bg-primaryBlue/5 rounded-lg">
        {/* <img
          src={theme === "dark" ? LucideSun  : LucideMoon}
          alt="Toggle theme icon"
        /> */}
        {theme === "dark" ? (
          <LucideMoon size={20} className="h-[18px] w-[18px] text-primaryBlue" />
        ) : (
          <LucideSun size={20} className="h-[18px] w-[18px] text-primaryBlue" />
        )}
        {/* <span className="text-sm md:text-xs opacity-50 hidden md:block">
          Toggle theme
        </span> */}
      </div>
    </button>
  );
};

export default ThemeToggler;